<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/jquery.png" /></div>
      <p>Jquery</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = 'https://uedcdn.zto.com/static/jquery/'
export default {
  name: 'index',
  data () {
    return {
      fileList: [{
        label: '3.3.1',
        linkList: [
          ur + '3.3.1/jquery.js',
          ur + '3.3.1/jquery.min.js',
          ur + '3.3.1/core.js'
        ]
      }, {
        label: '3.3.0',
        linkList: [
          ur + '3.3.0/jquery.js',
          ur + '3.3.0/jquery.min.js',
          ur + '3.3.0/core.js'
        ]
      }, {
        label: '3.2.1',
        linkList: [
          ur + '3.2.1/jquery.js',
          ur + '3.2.1/jquery.min.js',
          ur + '3.2.1/core.js'
        ]
      }, {
        label: '3.2.0',
        linkList: [
          ur + '3.2.0/jquery.js',
          ur + '3.2.0/jquery.min.js',
          ur + '3.2.0/core.js'
        ]
      }, {
        label: '2.2.4',
        linkList: [
          ur + '2.2.4/jquery.js',
          ur + '2.2.4/jquery.min.js'
        ]
      }, {
        label: '2.0.0',
        linkList: [
          ur + '2.0.0/jquery.js',
          ur + '2.0.0/jquery.min.js'
        ]
      }, {
        label: '1.12.4',
        linkList: [
          ur + '1.12.4/jquery.js',
          ur + '1.12.4/jquery.min.js'
        ]
      }]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/ListJquery.vue